module.exports = __webpack_public_path__ + "img/img-main-詠馨.10cbca99.png";